import * as types from './actionTypes'
import { apiUrl } from 'utils/config'
import { SubmissionError } from 'redux-form'

/*
 * Api thunks
 */
const api = {
	getHeaders: (needToken, token) => {
		const headers = {
			'Content-Type': 'application/json'
		}

		if (needToken)  {
			headers['Authorization'] = `Bearer ${token}`
			return headers

		} else {
			return headers
		}
	},
	_fetch: (uri, { method, body, needToken, token }) => fetch(`${apiUrl}${uri}`, {
		method: method,
		headers: api.getHeaders(needToken, token),
		body: JSON.stringify(body)
	}),
	get: (uri, params) => api._fetch(uri, { ...params, method: 'GET' }),
	put: (uri, params) => api._fetch(uri, { ...params, method: 'PUT' }),
	post: (uri, params) => api._fetch(uri, { ...params, method: 'POST' })
}

/*
 * Allocations entity
 */
export function receiveAllocations(json) {

	let byIds = {}

	json.map(entity => byIds[entity._id] = entity)

	return {
		type: types.RECEIVE_ALLOCATIONS,
		allocations: {
			byIds
		}
	}
}

export function fetchAllocations(triggerFetch) {
	return (dispatch, getState) => {
		const state = getState()
		const { allocations: { isFetching }, auth } = state
		if (isFetching !== null && !triggerFetch) return false
		return api.get('allocations', { needToken: true, token: auth.token })
			.then(response => response.json())
			.then(json => dispatch(receiveAllocations(json)))
	}
}

export function markLuckyAllocations(data) {

	let bodyData = {
		type: 'REAL'
	}

	return (dispatch, getState) => {
		const allAllocationRequests = data.map(d => {
			const state = getState()
			const { auth } = state
			return api.put(`allocations/${d}/type`, { needToken: true, token: auth.token, body: bodyData })
		})


		Promise.all(allAllocationRequests)
			//.then(response => response.json())
			.then(() => dispatch(fetchAllocations(true)))

	}
}

/*
 * Religions entity
 */
export function receiveReligions(json) {

	let byIds = {}

	json.map(entity => byIds[entity._id] = entity)

	return {
		type: types.RECEIVE_RELIGIONS,
		religions: {
			byIds
		}
	}
}

export function fetchReligions() {
	return (dispatch, getState) => {
		const state = getState()
		const { religions: { isFetching }, auth } = state
		if (isFetching !== null) return false
		return api.get('religions', { needToken: true, token: auth.token })
			.then(response => response.json())
			.then(json => dispatch(receiveReligions(json)))
	}
}

/*
 * States entity
 */
export function receiveStates(json) {

	let byIds = {}

	json.map(entity => byIds[entity._id] = entity)

	return {
		type: types.RECEIVE_STATES,
		states: {
			byIds
		}
	}
}

export function fetchStates() {
	return (dispatch, getState) => {
		const state = getState()
		const { states: { isFetching }, auth } = state
		if (isFetching !== null) return false
		return api.get('states', { needToken: true, token: auth.token })
			.then(response => response.json())
			.then(json => dispatch(receiveStates(json)))
	}
}

/*
 * Political affiliations entity
 */
export function receivePoliticalAffiliations(json) {

	let byIds = {}

	json.map(entity => byIds[entity._id] = entity)

	return {
		type: types.RECEIVE_POLITICAL_AFFILIATIONS,
		politicalAffiliations: {
			byIds
		}
	}
}

export function fetchPoliticalAffiliations() {
	return (dispatch, getState) => {
		const state = getState()
		const { politicalAffiliations: { isFetching }, auth } = state
		if (isFetching !== null) return false
		return api.get('political-affiliations', { needToken: true, token: auth.token })
			.then(response => response.json())
			.then(json => dispatch(receivePoliticalAffiliations(json)))
	}
}

/*
 * Settings entity
 */
export function receiveSettings(json) {
	return {
		type: types.RECEIVE_SETTINGS,
		settings: json
	}
}

export function fetchSettings() {
	return (dispatch, getState) => {
		const state = getState()
		const { settings: { isFetching }, auth } = state
		if (isFetching !== null) return false
		return api.get('settings', { needToken: true, token: auth.token })
			.then(response => response.json())
			.then(json => dispatch(receiveSettings(json)))
	}
}

export function updateSettings(data) {
	let fields = Object.keys(data).filter(function(key) {return data[key] === true})
	let settingsData = {
		reviewedSurveyInfo: fields,
		status: data.status
	}

	// Don't send empty arrays if updating status
	if(data.status) Object.keys(settingsData).forEach((key) => (!settingsData[key].length) && delete settingsData[key])

	return (dispatch, getState) => {
		const state = getState()
		const { auth } = state
		return api.put('settings', { needToken: true, token: auth.token, body: settingsData })
			.then(response => response.json())
			.then(response => {
				if (response.error) throw new SubmissionError({ _error: response.message})
				return response
			})
			.then(() => dispatch(fetchSettings()))
	}
}

/*
 * Stats entity
 */
export function receiveStats(json) {

	return {
		type: types.RECEIVE_STATS,
		stats: json
	}
}

export function fetchStats() {
	return (dispatch, getState) => {
		const state = getState()
		const { stats: { isFetching }, auth } = state
		if (isFetching !== null) return false
		return api.get('stats', { needToken: true, token: auth.token })
			.then(response => response.json())
			.then(json => dispatch(receiveStats(json)))
	}
}

/*
 * User data entity
 */
export function receiveUserData(json) {

	return {
		type: types.RECEIVE_USERDATA,
		userData: json
	}
}

export function fetchUserData() {
	return (dispatch, getState) => {
		const state = getState()
		const { userData: { isFetching }, auth } = state
		if (isFetching !== null) return false
		return api.get('users/me', { needToken: true, token: auth.token })
			.then(response => response.json())
			.then(json => dispatch(receiveUserData(json)))
	}
}

/*
 * Login
 */
export function loginSuccess(json) {

	return {
		type: types.RECEIVE_TOKEN,
		auth: json
	}
}

export function loginRequest(data) {
	return dispatch => {
		return api.post('auth/login', { body: data })
			.then(response => response.json())
			.then(response => {
				if (response.error) throw new SubmissionError({ _error: response.message})
				return response
			})
			.then(json => dispatch(loginSuccess(json)))

	}
}

/*
 * Logout
 */
export function logout() {
	return (dispatch, getStore) => {
		return dispatch({
			type: types.RESET,
			state: {
				_persist: getStore()._persist
			}
		})
	}
}




// WEBPACK FOOTER //
// ./src/redux/actions/actions.js